// eslint-disable-next-line max-classes-per-file
import React from 'react';
import {
  ValidatorComponent,
  SelectValidator,
  TextValidator,
  ValidatorForm
} from 'react-material-ui-form-validator';
import { withStyles } from '@material-ui/core/styles';
import { Exclamation } from 'assets/icons';
import { ErrorMessage } from 'components';
import { CTSUMuiSingleSelect } from './CTSUMuiSingleSelect';
import { CTSUMuiMultiSelect } from './CTSUMuiMultiSelect';

const styles = theme => ({
  error: {
    margin: '3px 0px 0px'
  }
});

class muiSelect extends ValidatorComponent {
  render() {
    const {
      name,
      title,
      className,
      value,
      classes,
      children,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    const { disabled, validators } = this.props;
    const calValue = value === false ? 'false' : value;
    const showError = (validators && validators.includes('required') && !calValue) || (!isValid && !disabled);
    return (
      <SelectValidator
        fullWidth
        title={title}
        variant="outlined"
        validators={validators}
        error={showError}
        className={`${className} input-mui-select`}
        value={value}
        FormHelperTextProps={{
          className: classes.error
        }}
        InputProps={{
          name,
          id: `${name}_simple`,
          endAdornment: showError && (
            <Exclamation />
          ),
          inputProps: {
            title,
            "data-id":`${name}_simple`
          }
        }}
        {...rest}
      >
        {children}
      </SelectValidator>
    );
  }
}

class muiTextBox extends ValidatorComponent {
  render() {
    const {
      title,
      name,
      className,
      value,
      classes,
      children,
      validators,
      inputClassName,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    const { disabled } = this.props;
    const showError = (validators && validators.includes('required') && !value) || (!isValid && !disabled);
    return (
      <TextValidator
        fullWidth
        title={title}
        variant="outlined"
        validators={validators}
        error={showError}
        className={`${className} input-mui-textbox`}
        value={value}
        FormHelperTextProps={{
          className: classes.error
        }}
        InputProps={{
          name,
          id: `${name}_simple`,
          endAdornment: showError && (
            <Exclamation />
          ),
          inputProps: {
            title,
            className: inputClassName || '',
            "data-id":`${name}_multi`
          }
        }}
        {...rest}
      >
        {children}
      </TextValidator>
    );
  }
}

class ReactSelect extends ValidatorComponent {
  render() {
    const { validators, value, disabled } = this.props;
    const { isValid } = this.state;
    const isValueValid = (validators && validators.includes('required') && !value) || (!isValid && !disabled);
    return (
      <>
        <CTSUMuiSingleSelect
          {...this.props}
          appendBody
          isValid={!isValueValid}
        />
        {this.errorText()}
      </>
    );
  }

  errorText() {
    const { isValid } = this.state;
    if (isValid) {
      return null;
    }
    return <ErrorMessage msg={this.getErrorMessage()} />;
  }
}

class ReactFormSelect extends ValidatorComponent {
  render() {
    const { validators, value, disabled } = this.props;
    const { isValid } = this.state;
    const isValueValid = (validators && validators.includes('required') && !value) || (!isValid && !disabled);
    return (
      <>
        <CTSUMuiSingleSelect
          {...this.props}
          appendBody={false}
          isValid={!isValueValid}
        />
        {this.errorText()}
      </>
    );
  }

  errorText() {
    const { isValid } = this.state;
    if (isValid) {
      return null;
    }
    return <ErrorMessage msg={this.getErrorMessage()} />;
  }
}

class ReactMultiSelect extends ValidatorComponent {
  render() {
    const { validators, value, disabled } = this.props;
    const { isValid } = this.state;
    const isValueValid = (validators && validators.includes('required') && !value) || (!isValid && !disabled);
    return (
      <>
        <CTSUMuiMultiSelect
          {...this.props}
          isValid={!isValueValid}
        />
        {this.errorText()}
      </>
    );
  }

  errorText() {
    const { isValid } = this.state;
    if (isValid) {
      return null;
    }
    return <ErrorMessage msg={this.getErrorMessage()} />;
  }
}

const MUISelect = withStyles(styles)(muiSelect);
const MUITextBox = withStyles(styles)(muiTextBox);

export {
  MUISelect, MUITextBox, ValidatorForm, ReactSelect, ReactMultiSelect, ReactFormSelect
};
